/**
 * 查看菜单
 * @author 3173
 * @date 2020-4-2
 */
import React from 'react';
import { connect } from 'dva';
import { framework_tool, component_tool, utils_tool } from '@/tool';
import { modelUtils } from "../../../utils";
let { WizModal, WizComponent, WizForm, WizCheckbox, WizRow, WizCol } = component_tool;
let { $$, checkStrLength } = utils_tool;
import '../../../styles/containers/auth/menu/index.less';

export default class LookUpMenu extends WizComponent {

  componentName = 'LookUpMenu';

  constructor(props) {
    super(props);
    this.state = {
    }
  }

  _rowView(title, value) {
    return (
      <WizRow className="look-row">
        <WizCol offset={2} span={4}>{title}:</WizCol>
        <WizCol offset={1} span={15}>{value}</WizCol>
      </WizRow>
    )
  }

  render() {
    const { record } = this.props;

    let menuElements = '';
    if (record && record.menuElements && record.menuElements instanceof Array) {
      record.menuElements.forEach(element => {
        menuElements += element.name + ','
      });
      if(menuElements.length>0){
        menuElements = menuElements.substring(0,menuElements.length-1)
      }
    }


    return (<div className="menu-item">
      {this._rowView('菜单名称', record.name)}
      {this._rowView('编号', record.number)}
      {this._rowView('上级菜单', record.parentName)}
      {this._rowView('类型', record.type==0?'文件夹':'菜单')}
      {this._rowView('菜单链接', record.url)}
      {this._rowView('菜单元素', menuElements)}
      {this._rowView('介绍', record.remark)}
      {this._rowView('状态', record.disabled==0?"有效":"无效")}
    </div>);
  }
}



